import { render, staticRenderFns } from "./ShoplistCategory.vue?vue&type=template&id=0c7fc6de&"
import script from "./ShoplistCategory.vue?vue&type=script&lang=js&"
export * from "./ShoplistCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7fc6de')) {
      api.createRecord('0c7fc6de', component.options)
    } else {
      api.reload('0c7fc6de', component.options)
    }
    module.hot.accept("./ShoplistCategory.vue?vue&type=template&id=0c7fc6de&", function () {
      api.rerender('0c7fc6de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/ShoplistCategory.vue"
export default component.exports